import { css } from '@emotion/react';

export const styles = {
  container: css`
    display: flex;
    justify-content: center;
    padding-bottom: 10px;
  `
};
